<template>
  <div class="public-bread-box">
    <ul class="public-item-box"> 
      <li v-for="(item,index) in breadList" :key="index">
        <router-link :to="item.path" v-if="item.path">{{item.name}}</router-link>
        <span v-else :style="{color:item.color}" :class="index == breadList.length -1?'last-item':''">{{item.name}}</span>
        <span class="bread-break" v-if="index != breadList.length -1">/</span>
      </li>
      <!-- <li><span style="color:lime">/ 已优化</span></li> -->
    </ul>
  </div>
</template>
<script>
export default {
  name: "breadCrumb",
  props: {
    breadList: {
      type: Array,
      require: true,
      default: () => {
        return [
          { name: "首页", path: "/home"} //path :需要跳转的页面路径
        ];
      }
    }
  },
  data() {
    return {
       
    };
  },
  methods: { 
  },
  created() {
   
  }
};
</script>
<style scoped lang='less'>
.public-bread-box {
  display: inline-block;
}
.public-item-box {
  height: 60px;
  display: flex;
  font-size: 14px;
  align-items: center;
  color: #999;
  li {
    cursor: pointer;
    a {
      color: #999;
      text-decoration: none;
    }
    .last-item{
        color: #333;
    }
  }
  .bread-break {
    margin: 0 5px;
  }
}
</style>
